import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./locales/de.json";

// Deutsch ist Standard. Englisch nur nach Klick auf den Umschalter (gespeichert in pb24_lang) oder ?lng=en.
// Keine Browsersprache: Googles Crawler meldet sich als en-US und hätte sonst die englische Seite indexiert (28.10.2026).
// Englische Texte werden erst bei Bedarf nachgeladen (kleineres Startprogramm).
function initialLang() {
  try {
    const q = new URLSearchParams(window.location.search).get("lng");
    if (q === "de" || q === "en") {
      localStorage.setItem("pb24_lang", q);
      return q;
    }
    return localStorage.getItem("pb24_lang") === "en" ? "en" : "de";
  } catch {
    return "de";
  }
}

async function loadEnglish() {
  if (!i18n.hasResourceBundle("en", "translation")) {
    const en = await import("./locales/en.json");
    i18n.addResourceBundle("en", "translation", en.default || en, true, true);
  }
}

const changeLanguage = i18n.changeLanguage.bind(i18n);
i18n.changeLanguage = async (lng, ...rest) => {
  if (lng === "en") await loadEnglish();
  return changeLanguage(lng, ...rest);
};

i18n.use(initReactI18next).init({
  resources: { de: { translation: de } },
  lng: "de",
  fallbackLng: "de",
  supportedLngs: ["de", "en"],
  interpolation: { escapeValue: false },
});

if (initialLang() === "en") i18n.changeLanguage("en");

export default i18n;
